import {jsonMapper} from "../utils/DataParser";
import {Auth} from "aws-amplify";
import moment, {Moment} from "moment";
import {BackendError} from "../model/BackendError";

class Backend {

    public static backUrl = process.env.REACT_APP_BACKEND_API_URL;

    private static DATE: string = 'YYYY-MM-DD';

    public static date = (d: Moment | Date) => {
        if (d) {
            if ('format' in d) {
                return d.format(Backend.DATE)
            } else {
                return moment(d).format(Backend.DATE)
            }
        } else {
            return "";
        }
    }

    public static async get(path: string): Promise<any> {
        return this.fetch(path, {
            method: 'get',
            headers: await this.buildHeaders(),
        })
    }

    public static async delete(path: string): Promise<any> {
        return this.fetch(path, {
            method: 'delete',
            headers: await this.buildHeaders(),
        })
    }

    public static async post(path: string, body: any): Promise<any> {
        return this.fetch(path, {
            method: 'post',
            headers: await this.buildHeaders(),
            body: jsonMapper.stringify(body)
        })

    }

    public static async put(path: string, body?: any): Promise<any> {
        return this.fetch(path, {
            method: 'put',
            headers: await this.buildHeaders(),
            body: body ? jsonMapper.stringify(body) : null
        })
    }

    private static async fetch(path: string, init: RequestInit): Promise<any> {
        return fetch(this.backUrl + path, init)
                .then(response => {
                    if (!response.ok) {
                        throw response
                    }
                    return response.text();
                })
                .then(bodyString => {
                    if (bodyString) {
                        return jsonMapper.parse(bodyString);
                    } else {
                        return {};
                    }
                }).catch(errorResponse => {
                    console.error("Error occurred", errorResponse)
                    if (errorResponse.text) {
                        return errorResponse.text()
                                .then(jsonMapper.parse)
                                .then((it: any) => {
                                    throw new BackendError(it.message, it.traceId, it.translation)
                                })
                    } else {
                        throw errorResponse;
                    }
                });
    }

    private static async buildHeaders() {
        const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();
        return {
            "Authorization": "Bearer " + token,
            'Accept': 'application/json;charset=UTF-8',
            'Content-Type': 'application/json;charset=UTF-8'
        }
    }
}

export default Backend;